/** A few generic global styles that are used throughout the app. */

export const cardShadow = "0px 7px 18px rgba(0, 0, 0, 0.04)";

export const header = {
  height: 40,
  verticalPadding: {
    xs: 2,
    md: 4,
  },
};

export const transitionFunction = "cubic-bezier(0.16, 1, 0.3, 1)";

export const checkeredBackground = {
  backgroundImage: `linear-gradient(45deg, #eee 25%, transparent 25%), 
  linear-gradient(-45deg, #eee 25%, transparent 25%), 
  linear-gradient(45deg, transparent 75%, #eee 75%), 
  linear-gradient(-45deg, transparent 75%, #eee 75%)`,
  backgroundSize: `20px 20px`,
  backgroundPosition: `0 0, 0 10px, 10px -10px, -10px 0px`,
};
